import { api } from './client'

export type NotificationSeverity = 'Info' | 'Warning' | 'Critical'

export interface InAppNotification {
  id: string; severity: NotificationSeverity; title: string; detail: string
  linkPath: string | null; createdAt: string; readAt: string | null
}

export const listMyNotifications = (doarNecitite = false, take = 50) =>
  api.get<InAppNotification[]>('/notificari/mele', { params: { doarNecitite, take } }).then((r) => r.data)
export const getUnreadNotificationCount = () =>
  api.get<{ count: number }>('/notificari/mele/numar-necitite').then((r) => r.data.count)
export const markNotificationRead = (id: string) => api.post(`/notificari/${id}/citeste`)
export const markAllNotificationsRead = () => api.post('/notificari/citeste-tot')
